var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header",class:['cl-' + _vm.Client]},[_c('div',{staticClass:"logo"})])}
var staticRenderFns = []

export { render, staticRenderFns }